import { render, staticRenderFns } from "./MaterialsTypeNavigation.vue?vue&type=template&id=43fcb8c4"
import script from "./MaterialsTypeNavigation.vue?vue&type=script&lang=js"
export * from "./MaterialsTypeNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
